import { gql } from "@apollo/client"

export const UpdateProfile = gql`
mutation UpdateProfile($updateProfileId: ID!, $content: contentProfile!) {
  updateProfile(id: $updateProfileId, content: $content) {
    status
  }
}
`